import { BaseError } from '@iotize/common/error';

export class InvalidConfigurationError extends BaseError {
  constructor(msg: string) {
    super(msg);
  }
}
